import type { Customer } from '../customer/customer.types';
import { CustomerAlertType } from './intervention.type';

export const getInterventionCustomerAlert = (customer: Customer) => {
  if (Boolean(customer.email) && customer.emailAlert && Boolean(customer.phone) && customer.smsAlert) {
    return CustomerAlertType.BOTH;
  }
  if (Boolean(customer.email) && customer.emailAlert) {
    return CustomerAlertType.EMAIL;
  }
  if (Boolean(customer.phone) && customer.smsAlert) {
    return CustomerAlertType.SMS;
  }
  return CustomerAlertType.NONE;
};
